module.exports = __webpack_public_path__ + "static/media/Leads.b65dce2e.png";